import { inject, injectable } from 'inversify';
import { ClientSeasonDependencyTypes } from '@client/entity/client-season/client-season.dependency-types';
import type { ClientSeasonRepositoryInterface } from '@client/entity/client-season/domain/repository/client-season.repository';
import type { ClientSeasonFillingRate } from '@client/entity/client-season/domain/model/client-season-filling-rate.model';

@injectable()
export class ClientSeasonService {
  public constructor(
    @inject(ClientSeasonDependencyTypes.ClientSeasonRepository)
    private readonly repository: ClientSeasonRepositoryInterface,
  ) {}

  public async getSubscriberProgress(clientId: string): Promise<ClientSeasonFillingRate | null> {
    return this.repository.fetchSubscriberProgress(clientId);
  }
}
